"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchInput = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSearchInput = (0, styled_components_1.default)(material_1.OutlinedInput) `
  && {
    height: ${({ theme }) => theme.spacing(6)};
  }
`;
